export default {
  selectedTab: '1',
  versionProps: {
    title: '轮播图',
    widgetNum: '2',// 每种组件的唯一编码
    version: '1',  // 每种组件的版本号
    upgrade: true,
    docUrl: '/datavisual/doc/widget'
  },
  viewProps: {
    width: '200',
    height: '100',
    top: 0,
    left: 0,
    fitType: 'cover',
    dataConfig: {
      data: [],
    }
  },
  datasourceProps: {
    datasourceType: 'STATIC', // STATIC/API
    dataMapping: {imgUrl: 'url', imgLink: 'link'},
    dataConfig: {
      'STATIC': {
        data: [
          {url:"https://gw.alicdn.com/imgextra/i1/1734167/O1CN01eXdllZ1geX1zdbBLa_!!1734167-0-lubanu.jpg_790x10000Q75.jpg_.webp",  link:"https://www.qq.com"},
          {url:"https://img.alicdn.com/tps/i4///img.alicdn.com/tps/i4//TB1CDhKUvb2gK0jSZK9SuuEgFXa.jpg_790x10000Q75.jpg_.webp",  link:"https://www.jd.com"},
          {url:"https://gw.alicdn.com/imgextra/i1/1800474/O1CN01lXTksu1FN8MIE9JZb_!!1800474-0-lubanu.jpg_790x10000Q75.jpg_.webp",  link:"https://www.baidu.com"},
          {url:"https://img.alicdn.com/tps/i4///img.alicdn.com/tps/i4//TB1CDhKUvb2gK0jSZK9SuuEgFXa.jpg_790x10000Q75.jpg_.webp",  link:"https://www.jd.com"},
        ]
      },
      'API': {// API时候的请求参数
        datasource: null,
        datasourceLabel: null,
        reqParams: null,
        data: null,
      },
    }
  }
}
